module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/logo_edge_new.8b58650da6e3582858982bc53d965edc.svg";